import React, { useCallback, useEffect, useState } from 'react';
import '../../src/assets/AdminCss/CricketScoreboard.css';
import axios from 'axios';
import { base_url } from '../context/Authcontext';

const CricketScoreboard = () => {
  const [team1Score, setTeam1Score] = useState({ runs: 0, wickets: 0, overs: 0, balls: 0 });
  const [team2Score, setTeam2Score] = useState({ runs: 0, wickets: 0, overs: 0, balls: 0 });
  const [currentRunRate, setCurrentRunRate] = useState({ team1: 0.00, team2: 0.00 });
  const [currentOver, setCurrentOver] = useState([]);
  const [matches, setMatches] = useState([]);
  const [battingTeamOvers, setBattingTeamOvers] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false); // NEW

  const selected1 = sessionStorage.getItem('runner1');
  const selected2 = sessionStorage.getItem('runner2');

  const toggleExpand = () => setIsExpanded(prev => !prev); // NEW

  const calculateRunRate = (runs, overs, balls) => {
    const totalOvers = overs + (balls / 6);
    return totalOvers > 0 ? (runs / totalOvers).toFixed(2) : "0.00";
  };

  const parseCurrentOverBalls = (lastData) => {
    try {
      if (!lastData) return [];
      const parts = lastData.split('|');
      if (parts.length === 0) return [];
      const ballsSection = parts[0].split('~');
      if (ballsSection.length < 3) return [];
      const ballsData = ballsSection[2].trim().split(' ').filter(ball => ball !== '');
      return ballsData;
    } catch (error) {
      console.error("Error parsing current over balls:", error);
      return [];
    }
  };

  const score = useCallback(async () => {
    const eventid = sessionStorage.getItem('eventid');
    try {
      const response = await axios.post(base_url + '/api/webapi/scoreboard',
        { eventid },
        { headers: { 'content-type': 'application/json' } }
      );
      const matchData = response?.data.result;

      if (matchData) {
        const matchParseData = JSON.parse(matchData);
        const homeTeam = matchParseData.h;
        const awayTeam = matchParseData.a;
        const isHomeBatting = matchParseData.tw === "h";
        const isAwayBatting = matchParseData.tw === "a";

        const homeTeamDisplay = isHomeBatting ? `${homeTeam}*` : homeTeam;
        const awayTeamDisplay = isAwayBatting ? `${awayTeam}*` : awayTeam;

        if (isHomeBatting) {
          setBattingTeamOvers(matchParseData.hs[0].o);
        } else {
          setBattingTeamOvers(matchParseData.as[0].o);
        }

        const formattedMatch = {
          e: matchParseData.e,
          en: matchParseData.en,
          t: matchParseData.t,
          mf: matchParseData.mf,
          h: homeTeamDisplay,
          a: awayTeamDisplay,
          hs: matchParseData.hs[0],
          as: matchParseData.as[0],
          s: matchParseData.s,
          m: matchParseData.m.replace("**|", ""),
          expanded: true,
        };

        setTeam1Score({
          runs: formattedMatch.hs.r,
          wickets: formattedMatch.hs.w,
          overs: formattedMatch.hs.o,
          balls: formattedMatch.hs.o * 6,
        });

        setTeam2Score({
          runs: formattedMatch.as.r,
          wickets: formattedMatch.as.w,
          overs: formattedMatch.as.o,
          balls: formattedMatch.as.o * 6,
        });

        const currentRunRate = {
          team1: calculateRunRate(formattedMatch.hs.r, formattedMatch.hs.o, formattedMatch.hs.w),
          team2: calculateRunRate(formattedMatch.as.r, formattedMatch.as.o, formattedMatch.as.w),
        };
        setCurrentRunRate(currentRunRate);

        const currentOverBalls = parseCurrentOverBalls(matchParseData.l);
        setCurrentOver(currentOverBalls.reverse());
        setMatches([formattedMatch]);
      }
    } catch (err) {
      console.error("Error fetching score data:", err);
    }
  }, []);

  useEffect(() => {
    score();
    const intervalId = setInterval(score, 5000);
    return () => clearInterval(intervalId);
  }, [score]);

  return (
    <div className="scoreboard-container">
      <div className="scoreboard-header" onClick={toggleExpand} style={{ cursor: 'pointer' }}>
        Score Board {isExpanded ? '▲' : '▼'}
      </div>

      {/* Collapsible Content */}
      {isExpanded && (
        <div className="overAll scoreboard-content">
          <div className="scoreboard-pitch">
            <div className="field-grid">
              {Array(12).fill().map((_, i) => (
                <div key={i} className="field-grid-line"></div>
              ))}
            </div>

            <div className="team-display team-left">
              <div className="team-name1">{matches?.[0]?.h || selected1}</div>
              <div className="team-score">
                {team1Score.runs}/{team1Score.wickets} ({team1Score.overs}ov)
              </div>
              <div className="run-rate">CRR {currentRunRate.team1}</div>
            </div>

            <div className="team-display team-right">
              <div className="team-name1">{matches?.[0]?.a || selected2}</div>
              <div className="team-score">
                {team2Score.runs}/{team2Score.wickets} ({team2Score.overs} ov)
              </div>
              <div className="run-rate">CRR {currentRunRate.team2}</div>
            </div>
          </div>

          <div className="over-display">
            <div className="over-label">Over {battingTeamOvers}</div>
            <div className="over-balls">
              {currentOver.length > 0 ? (
                currentOver.map((ball, idx) => (
                  <div key={idx} className="ball-marker no-score-ball">
                    {ball}
                  </div>
                ))
              ) : (
                <div className="no-balls-message">No balls bowled yet</div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CricketScoreboard;
